
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/[uuid]/success",
      function () {
        return require("private-next-pages/payment/[uuid]/success.tsx");
      }
    ]);
  